import { createSlice } from "@reduxjs/toolkit";
import {
  getTeacherAssessmentThunk,
  getCommonQuizTopicThunk,
  updateTeacherAssessmentThunk,
  createTeacherAssessmentThunk,
  deleteTeacherAssessmentThunk,
} from "./CommonMonthlyQuiz.Thunk";

const initialState = {
  data: [],
  topic: [],
  loading: false,
  status: "",
  message: "",
  language: "od",
  usertype: "fellow",
  type: "",
  topicId: "",
  topicName: "",
  disable_content_button: true,
};

const CommonMonthlyQuizSlice = createSlice({
  name: "commonmonthlyquizslice",
  initialState,
  reducers: {
    language_change: (state, action) => {
      state.language = action.payload;
      state.data = [];
      state.disable_content_button = true;
    },
    usertype_change: (state, action) => {
      state.usertype = action.payload;
      state.data = [];
      state.disable_content_button = true;
    },
    topic_change: (state, action) => {
      state.topicId = action.payload;
      state.topicName = action.payload;
      state.data = [];
      state.disable_content_button = false;
    },
    // assessment_change: (state, action) => {
    //   state.type = action.payload;
    //   state.data = [];
    //   state.disable_content_button = false;
    // },
  },
  extraReducers: {
    [getTeacherAssessmentThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getTeacherAssessmentThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getTeacherAssessmentThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },

    [getCommonQuizTopicThunk.pending]: (state, action) => {
      state.topic = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [getCommonQuizTopicThunk.fulfilled]: (state, action) => {
      state.topic = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [getCommonQuizTopicThunk.rejected]: (state, action) => {
      state.topic = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
    [createTeacherAssessmentThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [createTeacherAssessmentThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [createTeacherAssessmentThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },

    [updateTeacherAssessmentThunk.pending]: (state, action) => {
      state.data = [];
      state.loading = true;
      state.status = action.meta.requestStatus;
      state.message = "loading";
    },
    [updateTeacherAssessmentThunk.fulfilled]: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = "success";
    },
    [updateTeacherAssessmentThunk.rejected]: (state, action) => {
      state.data = [];
      state.loading = false;
      state.status = action.meta.requestStatus;
      state.message = action.error.message;
    },
  },
});

export const {
  language_change,
  usertype_change,
  topic_change,
  assessment_change,
} = CommonMonthlyQuizSlice.actions;

export default CommonMonthlyQuizSlice.reducer;
